import isBeforeDate from "validator/lib/isBefore";
import type { IValidatorParams } from "@edaz/services/baseValidationService";

export type IsBeforeOptions = IsBeforeOptions1 | IsBeforeOptions2;

interface IsBeforeOptions1 {
  condition: (entity: any) => Date | undefined;
  before?: undefined;
}

interface IsBeforeOptions2 {
  condition?: undefined;
  before: Date;
}

export default function isBefore(value: Date | undefined, options: IsBeforeOptions, params?: IValidatorParams) {
  if (value) {
    if (options.before) {
      return isBeforeDate(value?.toISOString(), options.before.toISOString());
    } else if (options.condition) {
      const before = options.condition(params?.entity);
      if (before) {
        return isBeforeDate(value?.toISOString(), before.toISOString());
      }
    }
  }

  return true;
}
